module.exports = "<img ng-src=\"../styles/images/common/newclaimvehicle/{{getIcon()}}.gif\"\r\n     id=\"{{part}}\" border=\"0\"\r\n     class=\"gw-damagePickerImage\"\r\n     ng-click=\"partClick(group, part)\"\r\n     ng-mouseover=\"hovered=true\"\r\n     ng-mouseout=\"hovered=false\"\r\n/>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/pa/directives/templates/vehicle-damageable-part.html
// module id = 670
// module chunks = 0